import { LoginResponseModel } from "api/repositories/authentications/model/LoginResponseModel";
import { PartnersResponse } from "api/repositories/partners/model/PartnersResponse";
import { SidebarMenuConfigModel } from "api/repositories/sidebarMenu/model/SidebarMenuConfigModel";
import { Dispatch, SetStateAction } from "react";

export class ContextModel {
  user: LoginResponseModel;
  getPartnerInfo: (value: any) => void;
  info: string;
  menuConfig: SidebarMenuConfigModel;
  partnerList: PartnersResponse[];
  setPartnerList: Dispatch<SetStateAction<PartnersResponse[]>>;
  getRoles: () => Promise<void>;
  getSidebar: (role: boolean) => Promise<void>;
  isAuthenticated: () => boolean;
  getConfig: () => Promise<void>;
  config: Object;
}
